import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@carnica/ui-kit';
import { Link } from '@beef/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { getFormattedTariffName, getIsOrangeComboButtonEnabled, getIsTariffAccumsFttbDivideEnabled, getUnbilledChargesText } from '@beef/elk-common/utils';
import { Metric } from "../../../../../utils/metric";
import { OrangeComboButton } from "../../../../OrangeCombo";
import { selectIsMobileUser, selectMainBalance, selectMobileConnectionBlockError, selectMobileConnectionTariff, selectMobileTariffPowerPending, selectShowUnbilledCharges, selectTariffBlock, selectTariffLink } from "../../store/selectors";
import { ConnectionBlockActionCreator } from "../../store/actions";
import { Card } from "../../../Card";
import { getNextBillingDate, getTariffPrice } from "../../utils";
import { selectClosestExpiringAdditionalAccumulatorInfo, selectMobileConnectionBlockPending, selectMobileConnectionBlockPricePending, selectRedesignMobileConnectionPrice, selectTariffPeriodDays, selectTariffPrice } from "./store";
import { selectUserType } from "../../../../../store/selectors";
import { Skeleton } from "../Skeleton";
import { Accumulators } from "../Accumulators";
import { ManageTariffButton } from "../ManageTariffButton";
import styles from "./styles.pcss";
import { TariffError } from "../TariffError";
import { InfoTag } from "./InfoTag";
import { getNextBillingInfo } from "../../utils/accumulators";
var cn = classNames.bind(styles);
var _MobileTariff = function _MobileTariff(_ref) {
  var name = _ref.name,
    price = _ref.price,
    periodDays = _ref.periodDays,
    billingDate = _ref.billingDate,
    pending = _ref.pending,
    tariffUrl = _ref.tariffUrl,
    userType = _ref.userType,
    hasError = _ref.hasError,
    fetchMobileConnection = _ref.fetchMobileConnection,
    fetchConnectionPrice = _ref.fetchConnectionPrice,
    additionalBillingInfo = _ref.additionalBillingInfo,
    showUnbilledCharges = _ref.showUnbilledCharges,
    mainBalance = _ref.mainBalance;
  var showOrangeCombo = getIsOrangeComboButtonEnabled();
  var isMobile = useIsMobileDimension();
  var nextBillingDate = getNextBillingDate(billingDate, false);
  var unbillingText = getUnbilledChargesText(showUnbilledCharges, nextBillingDate, mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.unbilledCharges);
  var showText = Boolean(unbillingText || nextBillingDate);
  var handleRefreshIconClick = function handleRefreshIconClick() {
    fetchMobileConnection();
    fetchConnectionPrice();
  };
  if (pending) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      "data-t-id": "components-MobileTariff"
    });
  }
  if (hasError) {
    return /*#__PURE__*/React.createElement(TariffError, {
      onClick: handleRefreshIconClick
    });
  }
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType
    }),
    events: {
      fubMetricSideMenu: ['handleTariffClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Link, {
    className: cn('link'),
    href: tariffUrl,
    isNoUnderline: true,
    "data-t-id": "components-MobileTariff"
  }, /*#__PURE__*/React.createElement(Card, {
    color: "primary",
    size: "m",
    "data-t-id": "components-MobileTariff"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title'),
    "data-t-id": "components-MobileTariff"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('name'),
    size: isMobile ? 'xs' : 'm'
  }, name), /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: isMobile ? 'xs' : 's'
  }, getTariffPrice(price, periodDays))), /*#__PURE__*/React.createElement(InfoTag, null), /*#__PURE__*/React.createElement(Accumulators, null), /*#__PURE__*/React.createElement(ManageTariffButton, {
    tariffUrl: tariffUrl
  }), showText && /*#__PURE__*/React.createElement(Text, {
    className: cn('description'),
    color: "tertiary-invert",
    size: isMobile ? '2xs' : 'xs'
  }, /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-MobileTariff"
  }, unbillingText), !!nextBillingDate && getNextBillingInfo(nextBillingDate, additionalBillingInfo)), showOrangeCombo && /*#__PURE__*/React.createElement(OrangeComboButton, null))));
};
var mapStateToProps = function mapStateToProps(state) {
  var _selectMobileConnecti, _selectRedesignMobile;
  var pending = selectMobileConnectionBlockPricePending(state) || selectMobileConnectionBlockPending(state) || selectMobileTariffPowerPending(state);
  var hasError = selectMobileConnectionBlockError(state);
  return {
    name: getFormattedTariffName((_selectMobileConnecti = selectMobileConnectionTariff(state)) === null || _selectMobileConnecti === void 0 ? void 0 : _selectMobileConnecti.title),
    price: selectTariffPrice(state),
    periodDays: selectTariffPeriodDays(state),
    shouldRender: selectIsMobileUser(state) && !getIsTariffAccumsFttbDivideEnabled() && (!!selectTariffBlock(state) || pending || hasError),
    billingDate: (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 || (_selectRedesignMobile = _selectRedesignMobile.data) === null || _selectRedesignMobile === void 0 ? void 0 : _selectRedesignMobile.billingDate,
    pending: pending,
    tariffUrl: selectTariffLink(state),
    userType: selectUserType(state),
    hasError: hasError,
    additionalBillingInfo: selectClosestExpiringAdditionalAccumulatorInfo(state),
    showUnbilledCharges: selectShowUnbilledCharges(state),
    mainBalance: selectMainBalance(state)
  };
};
var mapDispatchToProps = {
  fetchMobileConnection: ConnectionBlockActionCreator.fetchMobileConnection,
  fetchConnectionPrice: ConnectionBlockActionCreator.fetchConnectionPrice
};
export var MobileTariff = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_MobileTariff);